import React, { createContext, useState, useContext, useEffect } from 'react';

const ModuleProgressContext = createContext();

export const ModuleProgressProvider = ({ children }) => {
  const [moduleProgress, setModuleProgress] = useState({});

  useEffect(() => {
    // Load progress from localStorage if available
    const savedProgress = localStorage.getItem('moduleProgress');
    if (savedProgress) {
      try {
        setModuleProgress(JSON.parse(savedProgress));
      } catch (error) {
        console.error("Error loading module progress:", error);
      }
    }
  }, []);

  // Save progress to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('moduleProgress', JSON.stringify(moduleProgress));
  }, [moduleProgress]);

  const updateModuleProgress = (moduleId, data) => {
    setModuleProgress(prev => ({
      ...prev,
      [moduleId]: { ...prev[moduleId], ...data }
    }));
  };

  const resetModuleProgress = (moduleId) => {
    setModuleProgress(prev => {
      const newProgress = { ...prev };
      if (moduleId) {
        delete newProgress[moduleId];
      } else {
        return {};
      }
      return newProgress;
    });
  };

  return (
    <ModuleProgressContext.Provider 
      value={{ 
        moduleProgress, 
        setModuleProgress,
        updateModuleProgress,
        resetModuleProgress
      }}
    >
      {children}
    </ModuleProgressContext.Provider>
  );
};

export const useModuleProgress = () => {
  const context = useContext(ModuleProgressContext);
  if (context === undefined) {
    throw new Error('useModuleProgress must be used within a ModuleProgressProvider');
  }
  return context;
};

export default ModuleProgressContext; 